<template>
  <aside class="sidebar-menu" :class="{ open: value }" v-click-outside="close">
    <div class="mb-7 logo">
      <img :src="$config.get('logo_black')" />
      <img :src="$config.get('symbol')" />
    </div>

    <div class="menu-options">
      <div v-for="(option, i) in options" :key="i">
        <router-link v-if="option.route" :to="option.route">
          <i class="fs-24" :class="option.icon" />
          <span>{{ option.name }}</span>
        </router-link>

        <template v-else-if="option.context">
          <button
            @click="toggleContext(option.context)"
            :class="{ open: openContext == option.context }"
          >
            <i class="text-dark-20 ph ph-caret-right" />
            <i class="fs-24" :class="option.icon" />
            <span>{{ option.name }}</span>
          </button>

          <div
            class="context-menu"
            :class="{ open: openContext == option.context }"
          >
            <div class="menu-container">
              <div v-for="(opt, index) in option.options" :key="index">
                <router-link v-if="showOption(opt)" :to="opt.route">
                  <span>{{ opt.name }}</span>
                </router-link>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <profile-dropdown @logout="logoutDialog = true" />
    <confirmation
      v-model="logoutDialog"
      confirm-button-text="Sair"
      text="Tem certeza que deseja sair?"
      @confirm="logout"
    />
  </aside>
</template>

<script>
import { MENU_OPTIONS } from "@/constants/sideMenu";
import ProfileDropdown from "./ProfileDropdown/ProfileDropdown.vue";

export default {
  components: { ProfileDropdown },
  data() {
    return {
      openContext: "",
      logoutDialog: false
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    options() {
      return MENU_OPTIONS.filter(opt => this.showOption(opt));
    }
  },
  methods: {
    close() {
      if (this.value && window.innerWidth < 992) {
        this.$emit("input", false);
      }
    },
    showOption(option) {
      if (!option.permissions || !option.permissions.length) return true;

      return !!option.permissions.find(this.$permissions.hasPermission);
    },

    toggleContext(context) {
      if (this.openContext === context && this.value) {
        this.openContext = null;
      } else {
        this.openContext = context;
      }
      if (!this.value) this.$emit("input", true);
    },

    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>

<style lang="scss">
.sidebar-menu {
  min-width: var(--sidebar-width);
  width: var(--sidebar-width);

  @media screen and (max-width: 991px) {
    &:not(.open) {
      padding: 28px 0;
    }
  }

  background-color: var(--bg-1);
  border-right: 1px solid var(--dark-10);
  padding: 28px 16px;

  top: 0;
  left: 0;
  bottom: 0;
  height: 100vh;
  position: fixed;
  z-index: 2;

  transition: 0.4s all;

  display: flex;
  flex-direction: column;

  .menu-options {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &.open {
    padding: 28px 18px;
    min-width: var(--sidebar-width);
    width: var(--sidebar-width);
  }

  .logo {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    img {
      width: 100%;
      height: 32px;
      transition: all 0.4s;
      object-fit: contain;
      &:nth-child(2) {
        width: 0;
        opacity: 0;
      }
    }
  }
  @media screen and (min-width: 992px) {
    &:not(.open) .logo {
      img:first-child {
        width: 0;
        opacity: 0;
      }
      img:nth-child(2) {
        width: 100%;
        opacity: 1;
      }
    }
  }

  .menu-options {
    button,
    a {
      width: 100%;
      padding: 12px;
      font-size: 14px;
      color: var(--dark);
      border-radius: 12px;
      align-items: center;
      text-decoration: none;
      background-color: transparent;
      text-align: left;
      border: none;

      transition: 0.2s all;
      &.router-link-exact-active,
      &:hover {
        background: var(--bg-4);
        text-decoration: none;
        color: var(--dark);
      }

      span,
      i {
        white-space: nowrap;
        overflow: hidden;
      }
      overflow: hidden;
    }

    a {
      gap: 12px;
      display: grid;
      grid-template-columns: 24px 1fr;
    }
    button {
      gap: 8px;
      display: grid;
      grid-template-columns: 12px 24px 1fr;

      .ph-caret-right {
        transition: 0.2s all;
        transform: rotate(0deg);
      }
      &.open {
        .ph-caret-right {
          transform: rotate(-90deg);
        }
      }
    }
  }

  &:not(.open) {
    .menu-options {
      a {
        grid-template-columns: 24px 0fr;
      }
      button {
        grid-template-columns: 0px 24px 0fr;
        gap: 0;
      }
    }
  }

  .context-menu {
    display: grid;
    padding-left: 24px;
    grid-template-rows: 0fr;
    transition: 0.3s grid-template-rows;
    .menu-container {
      overflow: hidden;
    }
    a {
      display: inline-block;
    }
  }
  &.open .context-menu.open {
    grid-template-rows: 1fr;
  }

  .user-profile-dropdown {
    .dropdown-toggle {
      gap: 0px;
      display: grid;
      padding: 12px;
      border-radius: 12px;
      align-items: center;
      grid-template-columns: 24px 0px 0px;
      background-color: transparent;
      border: none;
      outline: none;
      transition: 0.4s grid-template-columns, 0.4s gap, 0.2s background-color;
      &::after {
        content: none;
      }
      &:hover {
        background-color: var(--bg-4);
      }
      span,
      i {
        overflow: hidden;
      }
    }
  }
  &.open {
    .user-profile-dropdown {
      .dropdown-toggle {
        grid-template-columns: 24px auto 1fr;
        gap: 16px;
      }
    }
  }
}
</style>
